"use client"

import {
  ArrowDownTray,
  ArrowUturnLeft,
  BookOpen,
  House,
  Tag,
  XCircle,
} from "@medusajs/icons"
import { useTranslations } from "next-intl"

import ResultPanel, {
  type ResultItem,
} from "@modules/common/components/result-panel"

/**
 * 段级兜底页。放在 [locale] 下而不是根目录，是因为它要渲染在
 * `app/[locale]/layout.tsx:19` 的 NextIntlClientProvider 内部，否则 useTranslations 不可用。
 * 它接得住 `(main)` 及其下所有 page，接不住 `[locale]/layout.tsx` 自身。
 *
 * 只有本文件的重试按钮带 error-retry；两份 404 不带（页面本来就不存在，重试是假动作）。
 */
export default function Error({
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const t = useTranslations("Errors")
  const tNotFound = useTranslations("NotFound")

  const items: ResultItem[] = [
    {
      kind: "action",
      icon: <ArrowUturnLeft className="size-4" />,
      title: t("retry"),
      description: t("retryDescription"),
      onClick: reset,
      testId: "error-retry",
    },
    {
      kind: "link",
      icon: <House className="size-4" />,
      title: tNotFound("homeTitle"),
      description: tNotFound("homeDescription"),
      href: "/",
    },
    {
      kind: "link",
      icon: <Tag className="size-4" />,
      title: tNotFound("pricingTitle"),
      description: tNotFound("pricingDescription"),
      href: "/#pricing",
    },
    {
      kind: "link",
      icon: <ArrowDownTray className="size-4" />,
      title: tNotFound("downloadTitle"),
      description: tNotFound("downloadDescription"),
      href: "/download",
    },
    {
      kind: "link",
      icon: <BookOpen className="size-4" />,
      title: tNotFound("changelogTitle"),
      description: tNotFound("changelogDescription"),
      href: "/changelog",
    },
  ]

  return (
    <ResultPanel
      icon={<XCircle className="size-6" />}
      title={t("generic")}
      description={t("requestFailed")}
      items={items}
      homeLabel={tNotFound("goHome")}
    />
  )
}
